export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-background-color-6539bc541d8d3a0817f67afaf31cd05f.svg";